export default __webpack_public_path__ + "18088b6711e04e51c0d6dc7334b1d701.svg";